const CompanyListHelper = {
  parseDocumentNumber: (companyList) => {
    return companyList.map((company) => {
      return {...company, deCpfCnpj: company.deCpf || company.deCnpjMatriz }
    })
  }
}


export default CompanyListHelper;
